@if (item?.type =='image' || item?.type =='video') {
  <div class="d-flex flex-column h-100">
    <label class="h-50 label-preview-title">{{item.templateOptions.label}} @if (item.templateOptions.required) {
      <span>*</span>
    }</label>
    <div class="h-50 d-flex flex-column justify-content-center">
      @if (item.type == 'video' && item.templateOptions['videoUrl']) {
        <div [ngClass]="{'image-with-label': item.templateOptions.label}" class="d-flex flex-column position-absolute-aligned p-1 w-100">
          <div class="video-container" [style.height]="getSubtitle() && subtitleHeight > 0 ? 'calc(100% - ' + (subtitleHeight + 8) + 'px)' : '100%'">
            @if (item.templateOptions.videoUrl && !isVideoFlow) {
              <video [src]="item.templateOptions.videoUrl | safeHtml" controls class="form-video" [attr.aria-label]="item.templateOptions.label"></video>
            }
            @if (isVideoFlow) {
              <video [src]="url | safeHtml"  controls class="form-video" #videoPlayer [attr.aria-label]="item.templateOptions.label"></video>
            }
          </div>
          @if (getSubtitle()) {
            <div #subtitleElement class="subtitle-fallback mt-2 fs-12" style="color: black; font-weight: normal;" role="caption" [attr.aria-label]="'Subtitle for ' + item.templateOptions.label">
              {{ getSubtitle() }}
            </div>
          }
        </div>
      }
      @if (item.type == 'image' && item.templateOptions.imgUrl) {
        <div [ngClass]="{'image-with-label': item.templateOptions.label}" class="d-flex position-absolute-aligned p-1">
          <div class="position-relative form-image-wrapper me-1 w-100">
            @if (item.templateOptions.imgUrl) {
              <img [src]="item.templateOptions.imgUrl | safeHtml" class="form-image">
            }
          </div>
        </div>
      }
    </div>
  </div>
}

@if (item?.type =='pdf') {
  <div class="d-flex flex-column h-100">
    @if (item.templateOptions.label) {
      <label class="label-preview-title mb-1" style="font-size: 12px; line-height: 1.2; padding: 2px 10px;">{{item.templateOptions.label}} @if (item.templateOptions.required) {
        <span>*</span>
      }</label>
    }
    <div class="flex-grow-1" style="padding: 10px; position: relative;" [ngClass]="{'image-with-label': item.templateOptions.imgUrl}">
      <div class="pdf-header">
        @if (isUpload) {
          <div class="d-flex align-items-center justify-content-center loading-upload">
            @if (isUpload) {
              <ng-container [ngTemplateOutlet]="loadingTemplateUpload"></ng-container>
            }
          </div>
        }
        <img src="assets/img/left-arrow.svg" alt="" class="me-2" (click)="pdfPrevious()">
        <input type="text" class="form-control mb-1 pdf-input me-2 text-white" [formControl]="pdfPage" (keyup.enter)="pageSearch()">
        <label class="" style="color:white">/ {{totalPages}}</label>
        <img src="assets/img/right-arrow.svg" alt="" class="ms-2" (click)="pdfNext()">
        <div class="pdf-download-button">
          <label class="cursor-pointer" style="color: #4f5053" (click)="downloadPdf(item.templateOptions)">
            <img src="assets/img/download-file.svg" alt="">
          </label>
        </div>
      </div>
      <app-pdf-page
        [src]="item.templateOptions.pdfUrl"
        [renderText]="true"
        [originalSize]="false"
        [page]="pdfPage.value"
        (pageChange)="pageChanged($event)"
        (loaded)="afterLoadComplete($event)"
        style="height: 100%"
      ></app-pdf-page>
    </div>
  </div>
}

<ng-template #loadingTemplateUpload>
  <div class="spinner-border m-5" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</ng-template>